(function () {

  function getVariant() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    return params.get("variant");
  }

  async function submitFavorite(handle, variant, customerId) {
    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        handle: handle,
        variant: variant,
        customerId: customerId,
      }),
    };
    await fetch("/tools/prime-review/api/addFavorite", fetchOptions);
    if (!customerId) {
      addCookieFavorite(variant);
    }else{
      changeFloatCount(1);
    }
  }

  window.PrimeReviewFavorite = {
    submitFavorite: submitFavorite
  }

  async function removeFavorite(handle, variant, customerId) {
    if (!customerId) {
      removeCookieFavorite(variant);
      return true;
    } else {
      const fetchOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          handle: handle,
          variant: variant,
          customerId: customerId,
        }),
      };
      await fetch("/tools/prime-review/api/removeFavorite", fetchOptions);
      changeFloatCount(-1);
    }
  }

  async function initFavorite(event) {
    event.preventDefault();
    const target = event.target;
    if (target.dataset.allowGuest != "true") {
      if (!target.dataset.customerId) {
        if (confirm(target.dataset.alert)) {
          location.href = `/account/login?checkout_url=${window.location.pathname}`;
        }
        return;
      }
    }

    target.disabled = true;
    target.innerText = target.dataset.sending

    const variant = getVariant() || target.dataset.defaultVariantId;

    await submitFavorite(target.dataset.handle, variant, target.dataset.customerId);

    target.style.display = "none";
    const existsMessage = document.getElementById("mxpr-already-exists");
    existsMessage.style.display = "none";
    const message = document.getElementById("mxpr-complete-message");
    message.style.display = "block";

  }

  function updateFloatCount(){
    const floatCountDiv = document.getElementById("prime-review-favorites-count");
    if(floatCountDiv){
      const favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
      let count = favorites.length;
      floatCountDiv.innerText = String(count);
      if(count <= 0){
        floatCountDiv.style.display = "none";
      }else{
        floatCountDiv.style.display = "block";
      }
    }
  }

  function changeFloatCount(add){
    const floatCountDiv = document.getElementById("prime-review-favorites-count");
    if(floatCountDiv){
      let count = Number(floatCountDiv.innerText) || 0;
      count = count + add;
      floatCountDiv.innerText = String(count);
      if(count <= 0){
        floatCountDiv.style.display = "none";
      }else{
        floatCountDiv.style.display = "block";
      }
    }
  }

  async function initLike(event) {
    event.preventDefault();
    const target = document.querySelector(".mxpr-like-heart");
    // console.log("*target.dataset: ", target.dataset);
    if (target.dataset.allowGuest != "true") {
      if (!target.dataset.customerId) {
        if (confirm(target.dataset.alert)) {
          location.href = `/account/login?checkout_url=${window.location.pathname}`;
        }
        return;
      }
    }

    const heartIcon = document.getElementById("mxpr-like-heart-icon");
    const loadingIcon = document.getElementById("mxpr-like-loading-icon");
    heartIcon.style.display = "none";
    loadingIcon.style.display = "block";

    const variant = getVariant() || target.dataset.defaultVariantId;

    let favoriteCount = Number(target.dataset.count || 0);
    if (target.dataset.active == "true") {
      await removeFavorite(target.dataset.handle, variant, target.dataset.customerId);
      favoriteCount = favoriteCount - 1;
      if (favoriteCount < 0) {
        favoriteCount = 0;
      }
      target.classList.remove("mxpr-like-heart-active");
      target.dataset.active = "false";
    } else {
      await submitFavorite(target.dataset.handle, variant, target.dataset.customerId);
      favoriteCount = favoriteCount + 1;
      target.classList.add("mxpr-like-heart-active");
      target.dataset.active = "true";
    }
    target.dataset.count = favoriteCount;
    const link = document.getElementById("mxpr-like-count-link");
    link.innerText = favoriteCount;

    heartIcon.style.display = "block";
    loadingIcon.style.display = "none";
  }

  function getVariantInfo(variantId) {
    const product = window.mxProductInfo;
    let variant;
    if (variantId) {
      variant = product.variants.find(v => v.id == variantId);
    }
    if (!variant) {
      variant = product.variants[0];
    }
    const variantInfo = {
      imageUrl: product.featured_image || null,
      url: window.location.href,
      title: product.title,
      handle: product.handle,
      variantTitle: variant.public_title,
      variantId: variant.id,
      price: variant.price,
      tags: product.tags
    };
    if(variant){
      variantInfo.variantId = variant.id;
      variantInfo.price = variant.price;
    }else{
      const prices = product.variants.map(v => v.price);
      variantInfo.minPrice = Math.min(...prices);
      variantInfo.maxPrice = Math.max(...prices);
    }

    return variantInfo;
    
  }

  function addCookieFavorite(variantId) {
    const favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
    if (!favorites.some(favorite => favorite.variantId == variantId)) {
      const variantInfo = getVariantInfo(variantId);
      favorites.push(variantInfo);
      localStorage.setItem('mxpr-favorites', JSON.stringify(favorites));
    }
    updateFloatCount();
  }

  function removeCookieFavorite(variantId) {
    const favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
    const index = favorites.findIndex(favorite => favorite.variantId == variantId);
    if (index >= 0) {
      favorites.splice(index, 1);
      localStorage.setItem('mxpr-favorites', JSON.stringify(favorites));
    }
    updateFloatCount();
  }

  // Cookieのお気に入り
  function checkCookies(button) {
    const favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
    const handle = button.dataset.handle;
    const count = Number(button.dataset.count || 0);
    if (favorites.some(favorite => favorite.handle == handle)) {
      if (button.classList.contains("mxpr-favorites-button")) {
        // 通常
        const messageElement = document.getElementById("mxpr-already-exists");
        if (messageElement) {
          messageElement.style.display = "block";
        }
      } else {
        // お気に入り
        button.classList.add("mxpr-like-heart-active");
      }
      button.dataset.active = "true";
      button.dataset.count = count + 1;
    }
  }

  const buttons = document.getElementsByClassName("mxpr-favorites-button");
  for (let i = 0; i < buttons.length; i++) {
    if (!buttons[i].dataset.customerId) {
      checkCookies(buttons[i]);
    }
    buttons[i].addEventListener("click", initFavorite);
  }
  const heartButton = document.querySelector(".mxpr-like-heart");
  if (heartButton) {
    if (!heartButton.dataset.customerId) {
      checkCookies(heartButton);
    }
    heartButton.addEventListener("click", (event) => initLike(event));
  }
  console.log("[INFO] Prime Review (Favorites) has been launched: version 5");
})();
